module.exports = __webpack_public_path__ + "img/00038.42d07c5a.webp";